import React, { useState } from 'react';
import '../Footer.css';
import PrivacyPolicyPopup from '../PrivacyPolicyPopup';

const Footer = () => {
  const [isPrivacyPopupOpen, setIsPrivacyPopupOpen] = useState(false);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-main-content">
            <div className="footer-logo">
              <img src="/logo.png" alt="Taibong Industries Inc." className="footer-logo-image" />
              <div className="footer-company-info">
                <h3 className="footer-company-name">Taibong Industries Inc.</h3>
                <p className="footer-company-english">태봉산업기술(주)</p>
              </div>
            </div>
            
            <div className="footer-center">
              <div className="footer-contact">
                <div className="contact-section">
                  <h4 className="contact-title">Head Office & Factory</h4>
                  <div className="contact-info">
                    <p>Address: 327 Namdong-ro, Namdong-gu, Incheon <br/>(Namdong Industrial Complex 43B-9L)</p>
                    <p>Tel: 032-811-0511</p>
                    <p>Email: saledept@taibong.com</p>
                  </div>
                </div>

                <div className="contact-section">
                  <h4 className="contact-title">Southern Office</h4>
                  <div className="contact-info">
                    <p>Address: 968 Haenghae-eup, Buk-gu, <br/>Pohang-si, Gyeongsangbuk-do</p>
                    <p>Tel: 054-231-0513</p>
                    <p>Email: shlee1@taibong.com</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <button 
            className="privacy-policy-btn privacy-policy-btn-desktop"
            onClick={() => setIsPrivacyPopupOpen(true)}
          >
            Privacy Policy
          </button>
          
          <button 
            className="privacy-policy-btn privacy-policy-btn-mobile"
            onClick={() => setIsPrivacyPopupOpen(true)}
          >
            Privacy Policy
          </button>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            Copyright (c) 2024 TAIBONG INDUSTRIES INC. All Rights Reserved.
          </p>
        </div>
      </div>
      
      <PrivacyPolicyPopup 
        isOpen={isPrivacyPopupOpen}
        onClose={() => setIsPrivacyPopupOpen(false)}
      />
    </footer>
  );
};

export default Footer;
